type NullOrUndefined = null | undefined;

export function isDefined<T>(value: T | NullOrUndefined): value is T {
  return value !== null && value !== undefined;
}
